import { useTheme } from '@mui/material';
import { useMemo } from 'react';

export interface CharitableTrustColors {
  crtNonCharitableColor: string;
  crtCharitableColor: string;
  cltNonCharitableColor: string;
  cltCharitableColor: string;
}

/**
 * Returns themed colors for charitable trust visualizations.
 * Uses the customer's data visualization palette when available,
 * falling back to static design tokens.
 */
export function useCharitableTrustColors(): CharitableTrustColors {
  const theme = useTheme();

  return useMemo(() => {
    return {
      crtNonCharitableColor: theme.palette.dataVisualizationPrimary.main,
      crtCharitableColor: theme.palette.dataVisualizationTertiary.main,
      cltNonCharitableColor: theme.palette.dataVisualizationTertiary.main,
      cltCharitableColor: theme.palette.dataVisualizationSecondary.main,
    };
  }, [theme.palette]);
}
